import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { ReservationStatus } from '@user-history/entities/reservation-status';
import { isConfirmReservationByStatus } from '@ux/mappers/reservation-status.mapper';
import { TagStatusSize, TagStatusType } from '@design-system/components/molecules/tag-status/entities/tag-status.types';

@Component({
  selector: 'app-status-reservation-type',
  templateUrl: './status-reservation-type.component.html',
  styleUrls: ['./status-reservation-type.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StatusReservationTypeComponent {

  @Input() status: ReservationStatus;

  public readonly tagStatusSize = TagStatusSize;

  constructor() { }

  get isConfimedReservation(): boolean {
    return isConfirmReservationByStatus(this.status);
  }

  get isPendingChangeReservation(): boolean {
    return this.status === ReservationStatus.PendingChange;
  }

  get tagStatusType(): TagStatusType {
    switch (this.status) {
      case ReservationStatus.Confirm:
      case ReservationStatus.Optimizing:
      case ReservationStatus.Exchanged:
        return TagStatusType.Success;
      case ReservationStatus.OnHold:
      case ReservationStatus.Solicited:
      case ReservationStatus.PendingChange:
        return TagStatusType.Processing;
      case ReservationStatus.Canceled:
      case ReservationStatus.Cancelled:
        return TagStatusType.Cancelled;
      case ReservationStatus.Expired:
      case ReservationStatus.Failed:
        return TagStatusType.Error;
      default:
        return TagStatusType.Original;
    }
  }
}
